<template>
  <div class="footer">
    <div class="footer-left">
      <span>©</span>
      <span class="text-copyright">&nbsp;Copyright</span>
      <strong class="text-inhouse">&nbsp;inHouse S.A.S&nbsp;</strong>
      <span class="text-reserve"> Todos los derechos reservados.&nbsp;</span>
    </div>
    <div class="footer-right">
      <span class="text-build">Desarrollado con&nbsp;</span>
      <span class="text-love">&#129293; MrDaza 2020</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "nav-footer"
}
</script>
